function fixStampedBadgeA11y() {
  document.querySelectorAll('span.stamped-badge[aria-label]').forEach((badge) => {
    if (badge.getAttribute('role') !== 'img') {
      badge.setAttribute('role', 'img')
    }

    badge.querySelectorAll('.stamped-starrating, .stamped-badge-caption').forEach((element) => {
      element.setAttribute('aria-hidden', 'true')
    })
  })
}

function updateStarRating() {
  const badges = document.querySelectorAll('.stamped-product-reviews-badge')

  badges.forEach((badge) => {
    const ratingElement = badge.querySelector('[data-rating]')
    if (!ratingElement) return

    const rating = parseFloat(ratingElement.getAttribute('data-rating'))
    const stars = badge.querySelectorAll('.stamped-fa-star')

    const fullStars = Math.floor(rating)
    const hasHalfStar = rating % 1 >= 0.5

    stars.forEach((star, index) => {
      star.classList.remove('full-star', 'half-star', 'empty-star')

      if (index < fullStars) {
        star.classList.add('full-star')
      } else if (index === fullStars && hasHalfStar) {
        star.classList.add('half-star')
      } else {
        star.classList.add('empty-star')
      }
    })
  })

  fixStampedBadgeA11y()
}

document.addEventListener('DOMContentLoaded', updateStarRating)

const observer = new MutationObserver(updateStarRating)
observer.observe(document.body, {
  childList: true,
  subtree: true,
  attributes: true,
  attributeFilter: ['data-rating', 'aria-label'],
})
